var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`${_vm.name}-icon`,{tag:"component",staticClass:"c-icon",attrs:{"fill":"currentColor","color":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }